// extracted by mini-css-extract-plugin
module.exports = {"section":"homepage-trending-djs_section_eTxNV"};